// Convert to local time
const getTimestamp = (connectionDate: string) =>
  // @ts-ignore
  Math.floor(new Date(connectionDate) / 1000);

export default getTimestamp;
